import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// v10-A1: welke week een call-week bespreekt, zoals de server het noemt ("Call ma 5 okt · over week 40").
export function useCallWeek(week) {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    let actief = true;   // R2-F8: het vorige label blijft staan tot het nieuwe binnen is
    if (week) api.get(`/call-week?week=${encodeURIComponent(week)}`).then((r) => { if (actief) setInfo(r.data); }).catch(() => {});
    return () => { actief = false; };
  }, [week]);
  return info;
}

export const callWeekTekst = (ci) => (ci ? `Call ${ci.callLabel} · over week ${ci.overWeekNr}` : "");
